var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 4.99992V14.5833C13.3334 16.4249 11.8417 17.9166 10.0001 17.9166C8.15841 17.9166 6.66675 16.4249 6.66675 14.5833V4.16658C6.66675 3.01659 7.60008 2.08325 8.75008 2.08325C9.90008 2.08325 10.8334 3.01659 10.8334 4.16658V12.9166C10.8334 13.3749 10.4584 13.7499 10.0001 13.7499C9.54175 13.7499 9.16675 13.3749 9.16675 12.9166V4.99992H7.91675V12.9166C7.91675 14.0666 8.85008 14.9999 10.0001 14.9999C11.1501 14.9999 12.0834 14.0666 12.0834 12.9166V4.16658C12.0834 2.32492 10.5917 0.833252 8.75008 0.833252C6.90841 0.833252 5.41675 2.32492 5.41675 4.16658V14.5833C5.41675 17.1166 7.46675 19.1666 10.0001 19.1666C12.5334 19.1666 14.5834 17.1166 14.5834 14.5833V4.99992H13.3334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attach_file.5de0b8f08be1ae123f33185ac15072d2.svg";
export { ForwardRef as ReactComponent };